export default [
'レギュラープラン',
'ゆっくりプラン',
'特急プラン',
'翌日納品プラン',
'当日納品プラン'
]